<h1>Export rewards</h1>

@if (!showNotFoundMsg) {
  <div>
    <app-bidirectional-selection [rewardList]="rewardsList" [currentSegment]="'export'" (sendRewardList)="exportToJSON($event, 'rewards')"></app-bidirectional-selection>
  </div>
}

@if (showNotFoundMsg) {
  <div>
    <p>No data...</p>
  </div>
}
